<template>
  <div v-if="operator">
    <v-divider class="my-8" />

    <v-row>
      <v-col cols="12" md="6">
        <v-row>
          <v-col>
            <h2>
              {{ $t('appointment.label.operator') }}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.name') }}
            </h6>
            <span class="body-2">
              {{ operator.name }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="operator && operator.phone" md="4">
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.phone') }}
            </h6>
            <span class="body-2" v-html="whatsApp(operator.phone)"></span>
          </v-col>
          <v-col>
            <h6 class="text-uppercase grey--text">
              {{ $t('appointment.label.email') }}
            </h6>
            <span
              class="body-2"
              v-html="mailto(operator.username)"
            ></span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mailto,
  whatsApp,
  catalogPhone
} from '@/util/catalog'

export default {
  name: 'AppointmentOperator',

  props: {
    appointment: {
      type: Object,
      required: true,
    }
  },

  computed: {
    operator() {
      return this.appointment.scheduled_by
    },
  },

  data() {
    return {
      mailto,
      whatsApp,
    }
  }
}
</script>
